<template>
  <div class="home">
    <header>
      <p class="home-title">
        活动
      </p>
    </header>
    <section>
      <!-- 轮播图 -->
      <!-- <div class="swipe">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item @click="skip_card_ecommend(item.url)" v-for="(item,index) in swipe_list" :key="index">
            <img :src=item.image alt="">
          </van-swipe-item>
        </van-swipe>
      </div> -->
      <!-- 下边框 -->
      <div class="bor-btm">
      </div>
      <!-- 特价活动 -->
      <div class="special-offers">
        <!-- 大标题 -->
        <p class="title">
          <span>
          </span> 
          精品推荐
        </p>
        <!-- 活动详情 -->
        <div class="activity-details" @click="activityDetailsBtn(item.id)" v-for="(item,index) in activity_List" :key="index">
          <!-- 活动标题 -->
          <div class="activity-details-title">
            <p>
              {{item.name}}
            </p>
            <span v-for="(item1,index1,) in item.lable" :key="index1" :class="tagStyle(index1)">
              {{item1}}
            </span>
          </div>
          <!-- 活动介绍 -->
          <p class="activity-details-introduce">
            {{item.desc}}
          </p>
          <div class="activity-details-img">
            <img :src=item.thumbnil alt="">
          </div>
        </div>
      </div>
    </section>
    <footer>
      <tabar></tabar>
    </footer>
  </div>
</template>

<script>
import tabar from '../../components/tabar/tabar'
import Vue from 'vue';
import { Swipe, SwipeItem } from 'vant';
Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  name: 'home',
  data(){
    return{
      activity_List: [], //精品推荐
      tag1: '', // 标签
      tag2: '', // 标签
      swipe_list: [], // 轮播图
      userId:'',
      present_url:'',
    }
  },
  created(){
    // 登录 / 分享登录
    let uid = JSON.parse(localStorage.getItem("uid"));
    if(!uid){
      let wxcode = this.$route.query.code
      // 获取code
      if(!wxcode){
        //appid 可以从后端传过来 也可以写死 
        let APPID = this.domain.APPID
        // 跳转回调redirect_uri 可以从后端传过来 也可以写死 但是url必须是公网可访问的
        let REDIRECT_URI = encodeURIComponent(this.domain.local_url)
        // 返回类型
        let code = 'code';
        // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且， 即使在未关注的情况下，只要用户授权，也能获取其信息 ）
        let SCOPE = 'snsapi_userinfo';
        let STATE = '123';//随便写
        let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + APPID + '&redirect_uri=' + REDIRECT_URI + '&response_type=' + code + '&scope=' + SCOPE + '&state=' + STATE + '#wechat_redirect';
        window.location.href = url;
        // console.log(url)
        // console.log(encodeURIComponent(this.domain.local_url))
      }else{
        // 传code
        this.$axios.get(this.domain.url+"/api/user/public/login",{
        params:{
          pid : uid,
          code : wxcode,
          url : this.domain.local_url
        },
        }).then((res) => {
          // console.log(res.data.data.uid)
          window.localStorage.setItem('uid',JSON.stringify(res.data.data.uid));
        })
      }
    }else{
      this.$axios.get(this.domain.url+"/api/home/index/islogin").then((res) => {
        // console.log(res)
        if(res.data.code == 0){
          window.localStorage.removeItem('uid');
          this.$router.go(0)
        }
      })
    }
  },
  mounted(){
    // 判断登录
    this.present_url = this.$route.path
    this.$axios.get(this.domain.url+"/api/home/index/islogin").then((res) =>{

    })
    // 轮播图
    this.$axios.get(this.domain.url+"/api/home/slides/1").then((res) => {
      // console.log(res.data.data)
      this.swipe_list = res.data.data[0].items
    })
    // 精品推荐
    this.$axios.get(this.domain.url+"/api/goods/index/recommendgoods").then((res) => {
      // console.log(res.data.data)
      this.activity_List = res.data.data
    })
  },
  methods:{
    // 标签样式
    tagStyle(index){
      return "person_" + index
    },
    // 轮播图活动详情
    skip_card_ecommend(url){
      // console.log(url)
      window.location.href = url
    },
    // 推荐详情
    activityDetailsBtn(id){
      // console.log(id)
      this.$router.push({
        path:'/activity-detail',
        query:{
          id:id
        }
      })
    }
  },
  components: {
    tabar
  }
}
</script>
<style lang="less" scoped>
  .home{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    header{
      width: 100%;
      height: .88rem;
      line-height: .88rem;
      text-align: center;
      font-family: PingFangSC-Regular;
      color: #FFFFFF;
      font-size: .36rem;
      background: linear-gradient(310deg,#232323 0%,#4A4A4A 57%,#333333 100%);
    }
    section{
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: scroll;
      flex: 1;
      // 轮播图
      .swipe{
        width: 6.9rem;
        height: 3.7rem;
        margin: 0 auto;
        margin-top: .2rem;
        .my-swipe .van-swipe-item {
          width: 100%;
          height: 100%;
          img{
            width: 100%;
            height: 3.32rem;
          }
          
        }
      }
      // 下边框
      .bor-btm{
        width: 100%;
        height: .2rem;
        background: #F4F4F4;
      }
      // 特价活动
      .special-offers{
        width: 100%;
        margin-top: .2rem;
        // 大标题
        .title{
          // width: 100%;
          font-family: PingFang-SC;
          color: #333333;
          font-size: .36rem;
          font-weight: 600;
          margin-bottom: .2rem;
          margin-left: .3rem;
          display: flex;
          align-items: center;
          span{
            display: block;
            width: .06rem;
            height: .36rem;
            background: #EF8201;
            margin-right: .1rem;
          }
        }
        // 活动详情
        .activity-details{
          width: 6.92rem;
          height: 5.18rem;
          margin: 0 auto;
          border-radius: .1rem;
          box-shadow:0rem 0.01rem 0.1rem 0rem rgba(0,0,0,0.22);
          overflow: hidden;
          // 活动标题
          .activity-details-title{
            width: 100%;
            height: .44rem;
            display: flex;
            align-items: center;
            margin-top: .22rem;
            // 标题
            p{
              font-family: PingFang-SC-Bold;
              font-size: .32rem;
              line-height: .32rem;
              color: #333333;
              font-weight: bold;
              margin-left: .2rem;
            }
            // 标签
            span{
              display: inline-block;
              width: .48rem;
              height: .24rem;
              font-size: .16rem;
              line-height: .24rem;
              color: #ffffff;
              border-radius:0.04rem;
              text-align: center;
            }
            // 样式
            .person_0{
              background: #FF0000;
              margin-left: .1rem;
            }
            .person_1{
              background: #7FBE39;
              margin-left: .04rem;
            }
          }
          // 活动介绍
          .activity-details-introduce{
            font-family: PingFangSC-Regular;
            color: #666666;
            font-size: .24rem;
            line-height: .24rem;
            margin-top: .2rem;
            margin-left: .2rem;
          }
          // 图片
          .activity-details-img{
            width: 6.52rem;
            height: 3.14rem;
            margin: 0 auto;
            margin-top: .42rem;
            img{
              width: 6.52rem;
              height: 3.14rem;
            }
          }
        }
      }
    }
  }
</style>
